/**
 * Implements menuTitle property per FB:69090
 */

import Brace from "backbone.brace";
import _ from "underscore";

const Model = Brace.Model.extend({
  namedAttributes: {
    data: Object,
    template: String,
  },
  defaults: {
    data: {},
    template: "",
  },
  getDisplay() {
    let title = "&nbsp;";

    // compile template and merge with data
    try {
      title = _.template(this.getTemplate())(this.getData());
    } catch (e) {
      // do nothing, let title be empty
    }

    return title;
  },
});

export { Model as default };
